import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledTriangleWithColor } from "./triangle-with-color.scss";
import DefaultProps from "./default-props";
import colors from "styles/colors";
class TriangleWithColor extends PureComponent {
    getStyle() {
        const { color } = this.props;
        return {
            borderTopColor: colors.white,
            borderRightColor: color,
            borderBottomColor: color,
            borderLeftColor: colors.white
        };
    }
    render() {
        const style = this.getStyle();
        return /*#__PURE__*/ _jsx(StyledTriangleWithColor, {
            className: "triangle-with-color",
            style: style
        });
    }
}
export { TriangleWithColor as default };
TriangleWithColor.defaultProps = DefaultProps;
